export class Point {

    public coordinates: number[];
    private type = 'Point';

    constructor(coordinates: number[]) {
        this.coordinates = coordinates;
    }
}
